import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ShopComponent } from './shop.component';

interface PaginationInterface {
  page: number;
  pages: { value: number; }[];
  results_per_page: number;
  total_hits: number;
  total_pages: number;
}

@Component({
  selector: 'app-pagination',
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
  templateUrl: './pagination.component.html'
})

export class PaginationComponent implements OnChanges {
  public pages: { value: number; }[];
  @Input('paginationData') pagination: PaginationInterface;

  constructor(
    private router: UIRouter,
    private location: Location,
    private shopComp: ShopComponent
  ) {}

  public ngOnChanges(): void {
    if (this.pagination.total_pages > 1) {
      this.createPagination();
    }
  }

  public navigateTo(action: string, id?: number): void {
    if (action && typeof action === 'string' && action.length > 0) {
      switch (action) {
        case 'next' :
          this.shopComp.updateResults('pagina', String(this.pagination.page += 1));
          break;
        case 'prev' :
          this.shopComp.updateResults('pagina', String(this.pagination.page -= 1));
          break;
        case 'first' :
          this.shopComp.updateResults('pagina', '1');
          break;
        case 'last' :
          this.shopComp.updateResults('pagina', String(this.pagination.total_pages));
          break;
        case 'goto' :
          if (id && id !== NaN) {
            this.shopComp.updateResults('pagina', String(id));
          }
          break;
        default :
          break;
      }
    }
  }

  private createPagination(): void {
    const _displayNumber = 5;

    if (this.pagination.total_pages > _displayNumber) {
      const _newPages: { value: number; }[] = [];
      const _numberOffset: number           = (_displayNumber - 1) / 2;
      let _leftOffset: number               = this.pagination.page - _numberOffset;
      let _rightOffset: number              = this.pagination.page + _numberOffset;
      let _i: number                        = 0;

      // Left boundry
      if (_leftOffset < 1) {
        _rightOffset = _displayNumber;
      } else {
        _i = _leftOffset -= 1;
      }

      // Right boundry
      if (_rightOffset > this.pagination.total_pages) {
        _rightOffset = this.pagination.total_pages;
        _i = this.pagination.total_pages - _displayNumber;
      }

      // Push new pages to array
      for (_i; _i < _rightOffset; _i += 1) {
        _newPages.push(this.pagination.pages[_i]);
      }

      this.pages = [..._newPages];
    } else {
      this.pages = [...this.pagination.pages];
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/pagination.component.ts